import { ElementType, FromTo, Location } from "../../../_objects/report-element";
import { PreviewControllerOfSection } from "./preview-controller-section";

export class PreviewControllerOfPage {
  private readonly headerController: PreviewControllerOfSection;
  private readonly bodyController: PreviewControllerOfSection;
  private readonly footerController: PreviewControllerOfSection;

  constructor() {
    this.headerController = new PreviewControllerOfSection();
    this.bodyController = new PreviewControllerOfSection();
    this.footerController = new PreviewControllerOfSection();
  }

  public previewElementsIds(): string[] {
    const headerPreviewIds = this.headerController.previewElementsIds();
    const bodyPreviewIds = this.bodyController.previewElementsIds();
    const footerPreviewIds = this.footerController.previewElementsIds();
    return headerPreviewIds.concat(bodyPreviewIds, footerPreviewIds);
  }

  public getIds(location: Location, type: ElementType): Array<string> {
    return this.getCore(location).getIds(type);
  }

  public draw(location: Location, type: ElementType, id: string | Array<string>): void;

  public draw(location: Location, type: ElementType, id: any): void {
    this.getCore(location).draw(type, id);
  }

  public move(type: ElementType, id: string, fromTo: FromTo): void {
    this.getCore(fromTo.from.location).remove(id);
    this.getCore(fromTo.to.location).draw(type, id);
  }

  public remove(location: Location, id: string | Array<string>): void;
  public remove(location: Location, id: any): void {
    this.getCore(location).remove(id);
  }

  public removeAll(location: Location, type: ElementType): void {
    this.getCore(location).removeAll(type);
  }

  private getCore(location: Location): PreviewControllerOfSection {
    let rtn: PreviewControllerOfSection;
    switch (location) {
      case Location.Header:
        rtn = this.headerController;
        break;
      case Location.Body:
        rtn = this.bodyController;
        break;
      case Location.Footer:
        rtn = this.footerController;
        break;
      default:
        // NOP
        break;
    }
    return rtn;
  }
}
